import { render, staticRenderFns } from "./admin-departments.vue?vue&type=template&id=b584bd7e&scoped=true"
import script from "./admin-departments.vue?vue&type=script&lang=js"
export * from "./admin-departments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b584bd7e",
  null
  
)

export default component.exports